(function() {
  'use strict';
  angular.module('benefits')
  .factory('Members',['$resource', 'teledentServiceUnavailableHandler',  function($resource, teledentServiceUnavailableHandler) {
    return $resource('/members',{},{
      query: {
        method: 'GET',
        isArray: false,
        transformResponse: teledentServiceUnavailableHandler(true)
      },
      associatedMembers: {
        method: "GET",
        url: "/members/:referenceId/associatedMembers",
        params: {referenceId:'@referenceId' },
        transformResponse: teledentServiceUnavailableHandler(true)
      },
      planSummary: {
        method: "GET",
        url:"/members/:referenceId/planSummary",
        params:{referenceId:'@referenceId'},
        transformResponse: teledentServiceUnavailableHandler(false)
      },
      planAccum: {
        method: "GET",
        url:"/members/:referenceId/planAccumulators",
        params:{referenceId:'@referenceId'},
        transformResponse: teledentServiceUnavailableHandler(false)
      },
      benefitInfo: {
        method: "GET",
        url:"/members/:referenceId/benefits",
        params:{referenceId:'@referenceId'},
        transformResponse: teledentServiceUnavailableHandler(false)
      },
      procedureHistory: {
        method: "GET",
        url:"/members/:referenceId/procedureHistory",
        params:{referenceId:'@referenceId'},
        transformResponse: teledentServiceUnavailableHandler(true)
      },
      copaySchedule: {
        method: "GET",
        url: "/dmo/:clientCode/plans/:planCode/copay-schedule",
        params: {clientCode:'@clientCode', planCode:'@planCode'},
        transformResponse: teledentServiceUnavailableHandler(false)
      },
      saveEligibilityHistory: {
          method: "POST",
          url:"/members/:referenceId/:uuid/eligibilityHistory",
          params:{referenceId:'@referenceId',uuid:'@uuid'},
          transformResponse: teledentServiceUnavailableHandler(false)
       },
       getEligibilityHistory: {
           method: "GET",
           url:"/members/:referenceId/:uuid/getEligibilityHistory",
           params:{referenceId:'@referenceId',uuid:'@uuid'},
           transformResponse: teledentServiceUnavailableHandler(false)
         },
    });
  }]);
})();
